import React, { useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PaddedContainer, DotSwitcher } from "@disco/disco_core";

import useWidgetOffer from "../../hooks/useWidgetOffer";
import { HorizontalSeparator } from "../CoreUI";
import isFunction from "../../utils/isFunction";
import EngageOfferSlot from "./EngageOfferSlot";
import "./engage-offer.css";

const animationVariants = {
	initial: {
		opacity: 0,
	},
	animate: {
		opacity: 1,
		transition: {
			opacity: { duration: 0.3, ease: "easeInOut" },
		},
	},
	exit: {
		opacity: 0,
		transition: {
			opacity: { duration: 0.2, ease: "easeInOut" },
		},
	},
};

const EngageBottomSlot = ({
	triggerResize,
	shouldRenderOffersSlot,
	setShouldRenderOffersSlot,
	onAnimationComplete,
}) => {
	const { activeOfferIdx, isFirstOffer, TOTAL_OFFERS } = useWidgetOffer();
	// Ref to track if the component is mounted to avoid animation on initial render
	const isInitialMount = React.useRef(true);

	useEffect(() => {
		if (isInitialMount.current) {
			isInitialMount.current = false;
		}
	}, []);

	return (
		<AnimatePresence
			mode="wait"
			onExitComplete={() => {
				triggerResize();
				if (isFunction(onAnimationComplete)) {
					onAnimationComplete();
				}
			}}
		>
			{shouldRenderOffersSlot && (
				<motion.div
					key="offers-slot"
					initial={isInitialMount.current ? false : "initial"}
					animate="animate"
					exit="exit"
					variants={animationVariants}
				>
					<HorizontalSeparator />
					<EngageOfferSlot
						key={activeOfferIdx}
						setShouldRenderOffersSlot={setShouldRenderOffersSlot}
					/>
					{!isFirstOffer && (
						<PaddedContainer vPadding={16} tightTop>
							<DotSwitcher
								viewOnly
								className="engage-widget-offers-navigator-dot-switcher"
								dots={TOTAL_OFFERS}
								active={activeOfferIdx}
								hMarginAuto
							/>
						</PaddedContainer>
					)}
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default EngageBottomSlot;
